import { Badge, Button, Col, Modal, Row } from "react-bootstrap";
import { Annotation, RADIOLOGY_REPORT_DETAILS_BY_ID, RadiologyReport, callQuery } from '../../amplify/appsync/query';
import { PatientVisit } from "../../amplify/appsync/search-patients";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { getUserFriendlyDate } from "../../utils/time";
import './OtherAnnotationModal.css';

/**
 * Modal showing other information
 */
export const OtherAnnotationModal = (props: {
    showModal: boolean,
    setShowModal: any,
    selectedAnnotations: Annotation[] | null,
    patientVisit: PatientVisit,
    addAnnotationToPlots: any,
}) => {

    const [radiologyReports, setRadiologyReports] = useState<RadiologyReport[]>([]);

    useEffect(() => {
        if (props.selectedAnnotations) {
            const reports: any = [];
            const asyncs: any = [];
            for (let selectedAnnotation of props.selectedAnnotations) {
                asyncs.push(callQuery({
                    operation: RADIOLOGY_REPORT_DETAILS_BY_ID,
                    imaging_id: selectedAnnotation.measure_value,
                }));
            }
            Promise.all(asyncs).then((values: any[]) => {
                for (let report of values) {
                    if (report) {
                        reports.push(report[0]);
                    }
                }
                setRadiologyReports(reports);
            })
        }
    }, [props.selectedAnnotations]);

    const formatImpression = (findings: string) => {
        // The findings are already correctly formatted in any new cases
        // return findings.replace(/(\d+\.\s)/g, '\n$1');
        return findings;
    }

    return (
        <Modal show={props.showModal} dialogClassName="modal-90w" onHide={() => props.setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Radiology Report ({radiologyReports.length})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    radiologyReports.length > 0 ? (
                        <>
                            {
                                radiologyReports.map((radiologyReport: RadiologyReport) => (
                                    <>
                                        <Row>
                                            <Col md={12} className="radiology-report-impression">
                                                <h5>{radiologyReport.study}{' '}{' '}
                                                    <Button variant={"outline-secondary"} 
                                                        onClick={() => {
                                                            // @ts-ignore - the result time is actually a string
                                                            props.addAnnotationToPlots(new Date(radiologyReport.result_time) / 1000, props.patientVisit, "eventMark", `${radiologyReport.study}`, 1);
                                                            props.setShowModal(false)
                                                        }} size="sm">
                                                        Add to Plot
                                                    </Button>
                                                </h5>
                                                {radiologyReport.impression ? (
                                                    <>{formatImpression(radiologyReport.impression)}</>
                                                ) : (
                                                    <span className="radiology-report-light">No impression at this time</span>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <h5>Insights</h5>
                                                {
                                                    radiologyReport.critical_gpt4 && (
                                                        <>
                                                            <Badge bg="primary">Critical</Badge>{' '}
                                                        </>
                                                    )
                                                }
                                                {radiologyReport.critical_finding ? (
                                                    <>{radiologyReport.critical_finding}</>
                                                ) : (
                                                    <span className="radiology-report-light">No insights at this time</span>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col md={12} className="radiology-report-metadata">
                                                Ordered: {getUserFriendlyDate(radiologyReport.order_time)}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} className="radiology-report-metadata">
                                                Reported: {getUserFriendlyDate(radiologyReport.result_time)}
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <hr />
                                        </Row>
                                    </>
                                ))
                            }
                        </>
                    ) : (
                        <Row>
                            <Col md={12}>
                                <FontAwesomeIcon icon={faSpinner} spin />
                            </Col>
                        </Row>
                    )
                }
            </Modal.Body>
        </Modal>
    );
};
